module.exports = __webpack_public_path__ + "img/health-guide-back.d4ea01e4.png";